module.exports = __webpack_public_path__ + "img/play-button.77dd35bc.png";